import { request } from '@/utils/ajax';

export interface MonthlyUsersDataPoint {
    year: number;
    month: number;
    developerCount: number;
    contractorCount: number;
    buyerCount: number;
    totalCount: number;
}

export interface MonthlyCompaniesDataPoint {
    year: number;
    month: number;
    developerCount: number;
    contractorCount: number;
}

export interface MonthlyUnitsDataPoint {
    year: number;
    month: number;
    unitCount: number;
}

export interface MonthlyProjectsDataPoint {
    year: number;
    month: number;
    projectCount: number;
}

export interface MonthlyMessagesDataPoint {
    year: number;
    month: number;
    threadCount: number;
    messageCount: number;
}

export interface MonthlyChangeRequestsDataPoint {
    year: number;
    month: number;
    approvedCount: number;
}

export interface MonthlyOrdersDataPoint {
    year: number;
    month: number;
    orderCount: number;
}

export interface MonthlyCasesDataPoint {
    year: number;
    month: number;
    caseCount: number;
}

export function getMonthlyUsers(): Promise<MonthlyUsersDataPoint[]> {
    return request('api/overTimeStatistics/users').then((r) => r.json());
}

export function getMonthlyCompanies(): Promise<MonthlyCompaniesDataPoint[]> {
    return request('api/overTimeStatistics/companies').then((r) => r.json());
}

export function getMonthlyUnits(): Promise<MonthlyUnitsDataPoint[]> {
    return request('api/overTimeStatistics/units').then((r) => r.json());
}

export function getMonthlyProjects(): Promise<MonthlyProjectsDataPoint[]> {
    return request('api/overTimeStatistics/projects').then((r) => r.json());
}

export function getMonthlyMessages(): Promise<MonthlyMessagesDataPoint[]> {
    return request('api/overTimeStatistics/messages').then((r) => r.json());
}

export function getMonthlyChangeRequests(): Promise<MonthlyChangeRequestsDataPoint[]> {
    return request('api/overTimeStatistics/change-requests').then((r) => r.json());
}

export function getMonthlyOrders(): Promise<MonthlyOrdersDataPoint[]> {
    return request('api/overTimeStatistics/orders').then((r) => r.json());
}

export function getMonthlyCases(): Promise<MonthlyCasesDataPoint[]> {
    return request('api/overTimeStatistics/cases').then((r) => r.json());
}
